import { render, staticRenderFns } from "./SafetyMeasuresItem.vue?vue&type=template&id=3ca5dab7&scoped=true&"
import script from "./SafetyMeasuresItem.vue?vue&type=script&lang=js&"
export * from "./SafetyMeasuresItem.vue?vue&type=script&lang=js&"
import style0 from "./SafetyMeasuresItem.vue?vue&type=style&index=0&id=3ca5dab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5dab7",
  null
  
)

export default component.exports